{
  "breadcrumbAriaLabel": "面包屑导航",
  "homeAriaLabel": "首页",
  "mainNavAriaLabel": "主导航",
  "closeSidebarAriaLabel": "关闭侧边栏",
  "collapse": "折叠",
  "help": "帮助",
  "settings": "设置",
  "myProfile": "我的资料",
  "groups": {
    "clinical": "临床",
    "worklists": "工作列表",
    "documentation": "病历文书",
    "orders": "医嘱",
    "medications": "药物",
    "scheduling": "预约排班",
    "billing": "计费",
    "analytics": "分析",
    "organization": "组织机构",
    "security": "安全",
    "accessReviews": "Access Reviews",
    "integrations": "集成",
    "system": "系统",
    "licensing": "许可"
  },
  "dashboard": "工作台",
  "patients": "患者管理",
  "patientSearch": "患者检索",
  "myPatients": "我的患者",
  "censusBedBoard": "在院 / 床位看板",
  "providerDirectory": "医师目录",
  "providerCoverage": "医师值班覆盖",
  "patientMerge": "患者合并",
  "inbox": "收件箱",
  "pendingResults": "待审结果",
  "criticalResults": "危急结果",
  "unsignedNotes": "未签署病历",
  "cosignQueue": "联签队列",
  "noteTemplates": "病历模板",
  "smartPhrases": "智能短语",
  "orderCatalog": "医嘱目录",
  "orderSets": "医嘱集",
  "encounters": "就诊记录",
  "orders": "医嘱",
  "results": "检验检查结果",
  "medications": "药物",
  "notes": "病历文书",
  "medicationWorklist": "Medication Worklist",
  "formulary": "药品目录",
  "pharmacistQueue": "药师审核队列",
  "appointments": "预约",
  "scheduleManagement": "排班管理",
  "waitlist": "候诊名单",
  "charges": "收费",
  "claims": "理赔",
  "payments": "支付",
  "accounts": "账户",
  "statements": "账单",
  "denials": "拒付",
  "analyticsDashboard": "工作台",
  "reports": "报表",
  "qualityMeasures": "质量指标",
  "healthSystems": "医疗集团",
  "facilities": "医疗机构",
  "locations": "院区位置",
  "clinicalTaxonomy": "临床分类",
  "serviceLocation": "服务 ↔ 地点",
  "providers": "医务人员",
  "users": "用户",
  "roles": "角色",
  "accessMatrix": "权限矩阵",
  "integrations": "集成",
  "thirdPartyApps": "第三方应用",
  "audit": "审计",
  "system": "系统",
  "cdsRules": "CDS 规则",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "检索",
    "register": "登记",
    "demographics": "基本信息",
    "census": "在院",
    "discharge": "出院",
    "catalog": "目录",
    "sets": "医嘱集",
    "pending": "待处理",
    "critical": "危急",
    "reconciliation": "用药核对",
    "worklist": "工作列表",
    "templates": "模板",
    "smartPhrases": "智能短语",
    "schedule": "排班管理",
    "quality": "质量指标",
    "administration": "管理",
    "auditLog": "审计日志",
    "allergies": "过敏史",
    "problems": "问题清单",
    "immunizations": "免疫接种",
    "insurance": "保险"
  },
  "handoffs": "交接",
  "duplicateReview": "重复病历审核",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "医嘱工作列表"
}
